module.exports = __webpack_public_path__ + "static/img/banner-18-sept-inggris.db31b28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-18-sept-inggris.png
// module id = KfvL
// module chunks = 1